import { render, staticRenderFns } from "./Formset.vue?vue&type=template&id=8f74e73c&scoped=true&"
import script from "./Formset.vue?vue&type=script&lang=js&"
export * from "./Formset.vue?vue&type=script&lang=js&"
import style0 from "./Formset.vue?vue&type=style&index=0&id=8f74e73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f74e73c",
  null
  
)

export default component.exports